export class FormFieldOptions {
	path: string;
	required?: boolean;
	cssClass?: string;
	editable?: boolean;
	label?: string;
	displayType?: string;
	validators?: any[];
	show?: FormFieldShowOptions;
	showEnumValues?: {
		key: string;
	}
	hidden?: boolean;
}

export class FormFieldDisplayOptions extends FormFieldOptions {
	category?: string;

	constructor() {
		super();
	}
}

export class FormFieldInputOptions extends FormFieldOptions {
	onlyDigits?: boolean;
	min?: number;
	max?: number;
	associtedPaths?: string[];
	isDropdown?: boolean;
	listItems?: any[];
	publicRecordMultiple?: string | 'single' | 'multiple';
	optionText?: string;
	optionValue?: string;
	prefix?: string;
	postfix?: string;

	constructor() {
		super();
	}
}

export class FormFieldShowOptions {
	label: boolean;
	value: boolean;

	constructor(label: boolean, value: boolean) {
		this.label = label;
		this.value = value;
	}
}
